var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext } from 'react';
import { useTicketTypesRecentlyUsedQuery } from 'apollo/queries/TICKET_TYPES_RECENTLY_USED';
import { TicketTypesContext } from 'context/TicketTypes/TicketTypesContext';
import useUserStore from 'stores/user';
var ANY_OPTION = {
    label: 'Any',
    value: null
};
export var useActiveTicketTypes = function (_a) {
    var _b;
    var isBulkCreateOnly = _a.isBulkCreateOnly, disabledOptions = _a.disabledOptions, ticketType = _a.ticketType, showAny = _a.showAny;
    var userId = useUserStore(function (s) { return s.userId; });
    var _c = useContext(TicketTypesContext), ticketTypes = _c.ticketTypes, ticketTypesLoading = _c.ticketTypesLoading;
    var _d = useTicketTypesRecentlyUsedQuery({
        variables: { navigator_id: userId, first: 5 },
        fetchPolicy: 'no-cache',
        skip: !userId
    }), data = _d.data, recentlyUsedLoading = _d.loading;
    var disabledCurrentOptions = new Set(disabledOptions);
    var recentlyUsedTypes = (((_b = data === null || data === void 0 ? void 0 : data.ticket_types) === null || _b === void 0 ? void 0 : _b.nodes) || []).map(function (item) { return (__assign(__assign({}, item), { disabled: disabledCurrentOptions.has(item.code) })); });
    var isTicketTypeInactive = ticketType
        ? !ticketTypes.some(function (type) { return type.id === ticketType.id; })
        : false;
    if (isTicketTypeInactive)
        disabledCurrentOptions.add(ticketType.code);
    var allOptions = isTicketTypeInactive
        ? __spreadArray([ticketType], ticketTypes, true) : ticketTypes;
    var getFilteredOptions = function (options) {
        if (options === void 0) { options = []; }
        return options.map(function (_a) {
            var id = _a.id, code = _a.code, display_name = _a.display_name, for_bulk_create = _a.for_bulk_create, survey_id = _a.survey_id, enable_surveys = _a.enable_surveys;
            return ({
                value: id,
                label: display_name,
                disabled: disabledCurrentOptions.has(code) ||
                    (isBulkCreateOnly && !for_bulk_create),
                surveyId: survey_id,
                enableSurveys: enable_surveys
            });
        });
    };
    var groups = new Set(['Recently Used']);
    allOptions.forEach(function (item) {
        var _a;
        if ((_a = item.group) === null || _a === void 0 ? void 0 : _a.display_name) {
            groups.add(item.group.display_name);
        }
    });
    var groupedOptions = Array.from(groups).map(function (group) { return ({
        label: group,
        title: group,
        options: getFilteredOptions(group === 'Recently Used'
            ? recentlyUsedTypes
            : allOptions.filter(function (item) {
                var _a;
                return ((_a = item.group) === null || _a === void 0 ? void 0 : _a.display_name) === group &&
                    !recentlyUsedTypes.some(function (t) { return t.id === item.id; });
            }))
    }); });
    var options = __spreadArray(__spreadArray([], (showAny ? [ANY_OPTION] : []), true), groupedOptions, true);
    return {
        options: options,
        loading: recentlyUsedLoading || ticketTypesLoading
    };
};
